import axios from 'axios';

const base = process.env.REACT_APP_BACK_URL || `${window.location.protocol}//${window.location.hostname}:5000`;

const auth = (token: string) => ({ headers: { Authorization: `Bearer ${token}` } });

export const getComerciosPuntos = async (token: string) => {
  const { data } = await axios.get(`${base}/puntos/comercios`, auth(token));
  return data as any[];
};

export const getComerciosResumen = async (token: string) => {
  const { data } = await axios.get(`${base}/puntos/comercios-resumen`, auth(token));
  return data as any[];
};

export const crearComercioPuntos = async (payload: { nombre: string; puntos_por_carga: number; activo?: boolean }, token: string) => {
  const { data } = await axios.post(`${base}/puntos/comercios`, payload, auth(token));
  return data;
};

export const actualizarComercioPuntos = async (id: number, payload: Partial<{ nombre: string; puntos_por_carga: number; activo: boolean }>, token: string) => {
  const { data } = await axios.put(`${base}/puntos/comercios/${id}`, payload, auth(token));
  return data;
};

export const subirLogoComercio = async (comercioId: number, file: File, token: string) => {
  const form = new FormData();
  form.append('file', file);
  const { data } = await axios.post(`${base}/files/comercios/${comercioId}/logo`, form, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'multipart/form-data',
    },
  });
  return data;
};

export const generarQrDinamico = async (comercioId: number, token: string, ttlSec = 60) => {
  const { data } = await axios.post(
    `${base}/puntos/qr/generar`,
    { comercio_id: comercioId, ttl_sec: ttlSec },
    auth(token)
  );
  return data as {
    token_qr: string;
    expires_at: string;
    expires_in_sec: number;
    comercio_id: number;
    comercio: string;
    logo_url?: string | null;
    puntos: number;
  };
};

export const listarAdminsComercio = async (comercioId: number, token: string) => {
  const { data } = await axios.get(`${base}/puntos/comercios/${comercioId}/admins`, auth(token));
  return data as Array<{ socio_id: number; nombre: string; mail?: string | null }>;
};

export const asociarAdminComercio = async (comercioId: number, socioId: number, token: string) => {
  const { data } = await axios.post(`${base}/puntos/comercios/admins`, { comercio_id: comercioId, socio_id: socioId }, auth(token));
  return data;
};

export const desasociarAdminComercio = async (comercioId: number, socioId: number, token: string) => {
  const { data } = await axios.delete(`${base}/puntos/comercios/${comercioId}/admins/${socioId}`, auth(token));
  return data;
};
